// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"39":"828e3bf6","130":"ab484c48","314":"277440d7","375":"ab484c48","406":"5eb192e5","472":"61a95192","660":"c6549730","727":"277440d7","767":"ab484c48","947":"6a5beb01"}[chunkId] + ".chunk.css";
};